import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, UtensilsIcon, FishIcon, SoupIcon, CakeIcon } from 'lucide-react';
const specialties = [{
  id: 1,
  title: 'Cordero asado en horno de leña',
  description: 'Nuestro cordero se asa lentamente en horno de leña tradicional, logrando una carne tierna y jugosa con piel crujiente. La estrella de los fines de semana.',
  icon: FlameIcon
}, {
  id: 2,
  title: 'Cochinillo asado',
  description: 'Cochinillo lechal asado al estilo castellano en nuestro horno de leña. Piel dorada y crujiente, carne que se deshace.',
  icon: UtensilsIcon
}, {
  id: 3,
  title: 'Pulpo asado',
  description: 'Pulpo cocinado a la brasa con aceite de oliva virgen extra y pimentón de la Vera. Un plato que enamora.',
  icon: FishIcon
}, {
  id: 4,
  title: 'Cocido madrileño',
  description: 'El auténtico cocido madrileño, servido en sus tres vuelcos tradicionales. Garbanzos, verduras, carnes y un caldo reconfortante.',
  icon: SoupIcon
}, {
  id: 5,
  title: 'Postres caseros',
  description: 'Tarta de queso, natillas, flan, crema catalana, tarta de la abuela y pudding casero. Todos hechos en nuestra cocina.',
  icon: CakeIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function SpecialtiesSection() {
  return <section id="especialidades" className="py-24 bg-laura-cream text-laura-dark" data-id="element-311">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
        <div className="text-center mb-16" data-id="element-313">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-314">
            Especialidades
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair text-laura-wood mb-8" data-id="element-315">
            Lo mejor de nuestra cocina
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-316">
          {specialties.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={item.id} variants={cardVariants} className={`bg-white rounded-lg p-8 shadow-md border border-laura-beige/50 hover:shadow-lg transition-shadow duration-300 ${index === specialties.length - 1 && specialties.length % 2 !== 0 ? 'md:col-span-2 md:max-w-2xl md:mx-auto w-full' : ''}`} data-id="element-317">
                <div className="flex items-start space-x-4" data-id="element-318">
                  <div className="bg-laura-olive/10 p-3 rounded-full flex-shrink-0" data-id="element-319">
                    <Icon className="w-6 h-6 text-laura-olive" data-id="element-320" />
                  </div>
                  <div data-id="element-321">
                    <h3 className="text-xl font-playfair font-bold text-laura-wood mb-3" data-id="element-322">
                      {item.title}
                    </h3>
                    <p className="text-laura-wood/80 leading-relaxed" data-id="element-323">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}